import debounce from '../utils/debounce';

export default function initScroll() {

  const $body = $('body');

  const handleScroll = () => {

    const scrollTop = $(window).scrollTop();

    $body.toggleClass('scrolled', scrollTop >= 150);

  };

  handleScroll();

  $(window).on(
    'scroll',
    debounce(handleScroll, 10)
  );

}



$('a[href^="#"]').on('click', function (e) {
  const target = $(this.getAttribute('href'));

  if (target.length) {
    e.preventDefault();

    const offset = 0;

    $('html, body').stop().animate(
      {
        scrollTop: target.offset().top - offset
      },
      800
    );
  }
});
